import { tickCastWindup } from '../domain/abilities/abilityCastTiming.js';
import { castLiveAbility } from './liveAbilityCast.js';

/**
 * Resolve queued Veigar W (and later kits) after castTime + effectDelay.
 */
export function tickPendingCastForEntity(entity, dt, ctx = {}) {
  const ready = tickCastWindup(entity, dt);
  if (!ready) return null;
  return castLiveAbility({
    player: entity,
    abilityKey: ready.abilityKey,
    cursor: ready.cursor,
    gameTime: ctx.gameTime || ready.gameTime || 0,
    entities: ctx.allDamageableTargets || ready.entities || [],
    selectedTarget: ready.selectedTarget,
    champKey: ready.champKey,
    skipWindup: true
  });
}
